// run-footer — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: block;
    background: var(--run-footer-bg, var(--run-color-surface-subtle));
    color: var(--run-footer-fg, var(--run-color-text-primary));
    font-size: var(--run-footer-font-size, var(--run-font-size-sm));
    font-family: var(--run-footer-font-family, var(--run-font-semantic-family-body));
  }

  .inner {
    max-width: var(--run-footer-max-width, 87.5rem);
    margin-inline: auto;
    padding-inline: var(--run-footer-gutter, var(--run-space-semantic-xs));
    padding-block-start: var(--run-footer-top-padding, var(--run-space-semantic-sm));
    padding-block-end: var(--run-footer-gutter, var(--run-space-semantic-xs));
  }

  .columns {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--run-footer-columns-gap, var(--run-space-semantic-sm));
  }

  @media (min-width: 40em) {
    .columns {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 64em) {
    .columns {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  run-divider {
    --run-divider-color: var(--run-footer-divider, var(--run-color-border-default));
    display: block;
    margin-block: var(--run-footer-gutter, var(--run-space-semantic-xs));
  }

  .bottom-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: var(--run-footer-gap, var(--run-space-semantic-xs));
    flex-wrap: wrap;
    color: var(--run-footer-text-color-secondary, var(--run-color-text-secondary));
  }

  ::slotted(a),
  .bottom-bar ::slotted(a) {
    color: var(--run-footer-link-color, var(--run-color-intent-primary-base));
  }
`;

export function render(host) {
  // No host properties declared in MVA SkinModule.render contract — purely structural
  host.shadowRoot.innerHTML = `
    <div class="inner">
      <div class="columns">
        <slot name="columns"></slot>
      </div>
      <run-divider aria-hidden="true"></run-divider>
      <div class="bottom-bar">
        <slot name="bottom-bar"></slot>
      </div>
    </div>
  `;
}